export enum CreateAccountStatus {
  CreatingAccount,
  AccountCreatedSuccess,
  RequireUserInput,
}
